export default __webpack_public_path__ + "static/Maintenance-Support-85355607f436684503eabb33cd268806.webp";